import facebook from '../assets/images/facebook-16.png';
import twitter from '../assets/images/twitter-16.png';
import insta from '../assets/images/insta.png';
import youtube from '../assets/images/youtube-16.png';
import footerLogo from '../assets/images/road2college_footer_logo.png';
import './footer.css';

export const FooterLayout = () => {
  return (
    <footer className="footer">
      <div className="top-footer-block">
        <div className="first-footer-block">
          <img
            onClick={() => window.open('https://www.road2college.com/')}
            src={footerLogo}
            alt="road to college icon"
          />
          <p className="disable-hover">
            Make smarter college finance descisions. <br />
            Become an educated customer of higher ed.
          </p>
          <p className="disable-hover rights-reserved">
            @{new Date().getFullYear()} Road2College. All Rights Reserved.
          </p>
        </div>
        <div className="second-footer-block">
          <h3>OUR TOOLS</h3>
          <p>
            <a target="_blank" href="https://www.road2college.com/coming-soon/" rel="noreferrer">
              CONCIERGE SERVICE
            </a>
          </p>
          <p>
            <a target="_blank" href="https://www.road2college.com/stages/compare/" rel="noreferrer">
              COMPARE COLLEGE OFFERS
            </a>
          </p>
          <p>
            <a target="_blank" href="https://collegeinsights.road2college.com/welcome" rel="noreferrer">
              COLLEGE INSIGHTS
            </a>
          </p>
        </div>
        <div className="third-footer-block">
          <h3>SUPPORT</h3>
          <p>
            <a target="_blank" href="https://www.road2college.com/coming-soon/" rel="noreferrer">
              FAQ
            </a>
          </p>
          <p>
            <a target="_blank" href="https://www.road2college.com/privacy-policy/" rel="noreferrer">
              PRIVACY POLICY
            </a>
          </p>
        </div>
        <div className="fourth-footer-block">
          <h3>CONNECT WITH US</h3>
          <div className="soc-net-icons">
            <a target="_blank" href="https://www.facebook.com/Road2College/" rel="noreferrer">
              <img className="soc-network" src={facebook} alt="facebook" />
            </a>
            <a target="_blank" href="https://twitter.com/Rd2College" rel="noreferrer">
              <img className="soc-network" src={twitter} alt="twitter" />
            </a>
            <a target="_blank" href="https://www.instagram.com/_road2college_/" rel="noreferrer">
              <img className="soc-network" src={insta} alt="instagram" />
            </a>
            <a target="_blank" href="https://www.youtube.com/channel/UCtooo7EcnUA16Z2pbWkUVXw" rel="noreferrer">
              <img className="soc-network" src={youtube} alt="youtube" />
            </a>
          </div>
          <p>
            <a target="_blank" href="https://www.road2college.com/contact-us/" rel="noreferrer">
              {' '}
              CONTACT US{' '}
            </a>
          </p>
          <p>
            <a target="_blank" href="https://www.road2college.com/coming-soon/" rel="noreferrer">
              PARTNER WITH US
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
